export enum RemoteSessionRecordingConditionLogicalOperator {
  AND = 'AND',
  OR = 'OR',
}
